import { DataTypeColumn } from '../../Common/commonColumnHelpers'
import { LodgingChain } from 'models/google_place_chain'
import {
  getGooglePlaceDoorBaseColumns,
  GooglePlaceDoorBaseWithProxyFields,
} from '../GooglePlaceBase/GooglePlaceDoorsBaseColumnsInfo'

export const LODGING_DOORS_COLUMNS = getGooglePlaceDoorBaseColumns('Lodging')

export const _typeCheck: Record<
  keyof GooglePlaceDoorBaseWithProxyFields & LodgingChain,
  DataTypeColumn
> = LODGING_DOORS_COLUMNS
